import { createContext } from 'react';
import type { AuthUser } from '../api/user';

export interface AuthContextValue {
  user: AuthUser;
  signOut: () => Promise<void>;
}

/** Provided by RequireAuth. Throws if used outside RequireAuth. */
export const AuthContext = createContext<AuthContextValue | null>(null);
